import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles({
  headerRow: {
    display: "flex",
    alignItems: "center",
  },
  titleRow: {
    display: "flex",
    alignItems: "center",
    gap: 8,
  },
  countBadge: {
    fontSize: "0.7rem",
    fontWeight: 600,
    background: "#e0e0e0",
    color: "#424242",
    padding: "1px 8px",
    borderRadius: 10,
    lineHeight: "16px",
  },
  listContainer: {
    padding: "0 16px 12px",
  },
  searchField: {
    marginBottom: 12,
  },
  defaultSection: {
    marginBottom: 16,
    paddingBottom: 16,
    borderBottom: "1px solid #e0e0e0",
  },
  defaultSectionNoDivider: {
    marginBottom: 0,
  },
  defaultSectionLabel: {
    display: "block",
    marginBottom: 6,
    fontWeight: 600,
  },
  defaultSectionContent: {
    border: "1px solid #e0e0e0",
    borderRadius: 4,
    backgroundColor: "#fafafa",
  },
  noDefault: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "14px 16px",
    minHeight: 80,
  },
  list: {
    border: "1px solid #e0e0e0",
    borderRadius: 4,
  },
  empty: {
    padding: "32px 16px",
    textAlign: "center",
  },
  listSubHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 6,
  },
  listSubHeaderLabel: {
    fontWeight: 600,
  },
  pagination: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 4,
    marginTop: 8,
  },
  skeletonRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "14px 16px",
    borderBottom: "1px solid #eee",
    "&:last-child": { borderBottom: "none" },
  },
  skeletonInfo: {
    display: "flex",
    flexDirection: "column",
    gap: 10,
    flex: 1,
  },
  skeletonChips: {
    display: "flex",
    gap: 4,
  },
  skeletonActions: {
    display: "flex",
    gap: 4,
    marginLeft: 12,
  },
});
